var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 181,
  height: 113,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "plus-lighter"
  },
  opacity: 0.2,
  stroke: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "plus-lighter"
  },
  d: "M0 .5h180M.5 1v112M15.5 1v112M30.5 1v112M45.5 1v112M60.5 1v112M75.5 1v112M90.5 0v113M105.5 1v112M120.5 1v112M135.5 1v112M150.5 1v112M165.5 1v112M180.5 0v113M0 14.5h180M0 28.5h180M0 42.5h180M0 56.5h180M0 70.5h180M0 84.5h180M0 98.5h180M0 112.5h180"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 78C43 78 93.5 8 120.5 8 136 8 151 79 151 112",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 78c42 0 63.5-21.5 89-21.5 19 0 38 32 38 55.5",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round"
})));
export default SvgGraph;